export const MESSAGES = {
    SUCCESS: {
        DEMO_FORM_SUBMITTED: "Thank you for submitting your email address. <br/> We'll get in touch with you soon."
    }
}